import $ from 'jquery';

$.fn.clearForm = function() {
    return this.each(function() {
        var type = this.type, tag = this.tagName.toLowerCase();
        if (tag == 'form') {
            $(':input', this).clearForm();
            return;
        }
        if (type == 'text' || type == 'password' || tag == 'textarea')
            this.value = '';
        else if (type == 'checkbox' || type == 'radio')
            this.checked = false;
        else if (tag == 'select') {
            if (this.selectize)
                this.selectize.setValue('');
            else
                this.selectedIndex = 0;
        }

        $(this).trigger('change');
    });
};



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/common/js/clearform.js
 **/